"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChainBroken;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ChainBroken(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "chain-broken"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.728,11.54A14.467,14.467,0,0,0,72.79,7.18L53.33,19.658a14.454,14.454,0,0,0-5.516,17.71l-1.2.767a2.5,2.5,0,1,0,2.7,4.209l1.192-.764a14.32,14.32,0,0,0,2.1,1.877,14.546,14.546,0,0,0,16.3.5L88.369,31.478A14.465,14.465,0,0,0,92.728,11.54Zm-2.949,9.8a9.36,9.36,0,0,1-4.109,5.928L66.209,39.747a9.517,9.517,0,0,1-10.66-.334,9.325,9.325,0,0,1-.732-.6L65.294,32.1a2.5,2.5,0,1,0-2.7-4.209L52.122,34.606a9.443,9.443,0,0,1,3.907-10.739l19.46-12.478a9.417,9.417,0,0,1,14.29,9.952Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.9,49.731l.664-1.062a2.5,2.5,0,1,0-4.238-2.653l-.666,1.065a13.183,13.183,0,0,0-17.065,4.783L7,73.607a13.2,13.2,0,0,0,4.179,18.145l2.145,1.341h0a13.176,13.176,0,0,0,18.144-4.18l13.6-21.745A13.2,13.2,0,0,0,41.9,49.731ZM40.826,64.517l-13.6,21.745A8.174,8.174,0,0,1,15.97,88.854l-2.144-1.342a8.2,8.2,0,0,1-2.593-11.254l13.6-21.743a8.172,8.172,0,0,1,10.153-3.16L28.259,62.108A2.5,2.5,0,0,0,32.5,64.76l6.726-10.753a8.187,8.187,0,0,1,1.6,10.51Z"
  })))));
}